import { useState } from "react";

import StatsDebtors from "../StatsDebtors/StatsDebtors";
import { categotiesInStats } from "@/utils/constants";

import "../../PatientDetailsPageMain/PatientDetailsPageMain.scss";
import "./StatsMain.scss";

export default function StatsMain() {
    const [activeCategory, setActiveCategory] = useState("deptors");

    function renderContent() {
        switch (activeCategory) {
            case "deptors":
            default:
                return <StatsDebtors />;
        }
    }

    return (
        <main className='main_content_container stats_main_container'>
            <section className='header_in_main_content'>
                <div className='header_selector'>
                    {categotiesInStats.map(category => (
                        <p
                            key={category.id}
                            className={
                                activeCategory === category.id
                                    ? "active_category"
                                    : ""
                            }
                            id={category.id}
                            onClick={() => setActiveCategory(category.id)}
                        >
                            {category.name}
                        </p>
                    ))}
                </div>
            </section>
            {renderContent()}
        </main>
    );
}
